import { Component, inject } from '@angular/core';
import { UIDialogComponent, UIModule, UINewThemeService } from '@bannerflow/ui';
import { ICampaignStatus } from '@studio/domain/campaigns';
import { NavigationService } from '../../../shared/services/navigation.service';

@Component({
    imports: [UIModule],
    selector: 'delete-creative-dialog',
    templateUrl: './delete-creative-dialog.component.html',
    styleUrls: [
        './delete-creative-dialog.component.scss',
        './delete-creative-dialog.new.component.scss'
    ]
})
export class DeleteCreativeDialogComponent {
    private navigationService = inject(NavigationService);
    private dialog = inject(UIDialogComponent);
    private uiNewThemeService = inject(UINewThemeService);

    campaigns: ICampaignStatus[] = [];
    isNewUI = this.uiNewThemeService.isNewThemeEnabled;

    constructor() {
        this.campaigns = this.dialog.config.data.campaigns as ICampaignStatus[];
    }

    openCampaign(campaignId: string): void {
        this.navigationService.openCampaign(campaignId);
    }

    cancel(): void {
        this.dialog.dialogRef.close();
    }
}
